<template>
  <div>
    <md-field>
      <gl-icon-calendar />
      <md-input ref="input" @input="changeDate" type="text" required></md-input>
    </md-field>
  </div>
</template>

<script>
import flatpickr from 'flatpickr'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import 'flatpickr/dist/themes/material_blue.css'
import { dateLimit } from '@/util/date'

export default {
  props: {
    /**
     * カレンダーで選択できる最小の日付（この日付を**含む**）
     */
    min: {
      type: String,
      required: true,
      validator(value) {
        const regex = new RegExp(/^\d{8}$/g)
        return regex.test(value)
      },
    },
    /**
     * カレンダーで選択できる最大の日付（この日付を**含む**）
     */
    max: {
      type: String,
      required: true,
      validator(value) {
        const regex = new RegExp(/^\d{8}$/g)
        return regex.test(value)
      },
    },
    /**
     * 選択されている日付
     */
    value: {
      type: String,
      validator(value) {
        const regex = new RegExp(/^\d{8}$/g)
        return regex.test(value)
      },
    },
  },
  data() {
    return {
      picker: undefined,
    }
  },
  watch: {
    min(date) {
      this.setPickerOption('minDate', date)
    },
    max(date) {
      this.setPickerOption('maxDate', date)
    },
    value(date) {
      this.picker.setDate(date)
    },
  },
  methods: {
    setPickerOption(option, value) {
      if (this.picker) {
        this.picker.set(option, value)
      }
    },
    changeDate(date) {
      this.$emit('update:value', dateLimit(date, this.min, this.max))
    },
  },
  mounted() {
    this.picker = flatpickr(this.$refs.input.$el, {
      locale: Japanese,
      altFormat: 'Y年n月j日',
      altInput: true,
      dateFormat: 'Ymd',
      // デフォルト日付に何かしらmin, max間の値を入れないとmin, maxが効かない？
      defaultDate: this.value || this.min,
      minDate: this.min,
      maxDate: this.max,
    })
    this.$on('hook:beforeDestroy', () => this.picker.destroy())
  },
}
</script>
